import AbstractModel from './AbstractModel';

class SubcontractorCategoryModel extends AbstractModel {}

export default SubcontractorCategoryModel;
